module.exports = __webpack_public_path__ + "img/vinil_negro.02395f02.jpg";